<template>
  <div class="container-fluid p-0">

    <link href="//cdn.datatables.net/1.10.22/css/jquery.dataTables.min.css" rel="stylesheet" />
    <link href="https://cdn.datatables.net/buttons/1.6.4/css/buttons.dataTables.min.css" rel="stylesheet" />
    
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">{{ txt("Phone") }}</h1>
    </div>

    <!-- Summary Section -->
    <div class="row mb-3" v-if="summary">
      <div class="col-lg-12">
        <div class="card shadow">
          <div class="card-header py-3">
            <h6 class="m-0 font-weight-bold text-primary">Phone Statistics</h6>
          </div>
          <div class="card-body">
            <canvas id="phoneStatsChart" height="80"></canvas>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">

        <div class="table-responsive">
          <table
            id="table-phones"
            class="table table-sm table-hover table-striped- display"
            style="width: 100%"
          >
            <thead>
              <tr>
                <!-- <th>ID</th> -->
                <th>Name</th>
                <th>State</th>
                <!-- <th>tags</th> -->
                <th><i class="fas fa-sim-card"></i> SIM</th>
                <th><i class="fa fa-mobile-alt"></i> &nbsp; HOST</th>
                <th><i class="fa fa-mobile-alt"></i> &nbsp; PORT</th>
                <th><i class="fa fa-laptop"></i> &nbsp; HOST</th>
                <th><i class="fa fa-laptop"></i> &nbsp; PORT</th>
                <th>Phone number</th>
                <th>{{ txt("Estimated balance") }}</th>
                <th>Remark</th>
                <th>___________Setting___________</th>
                <th>Job exchange rate</th>
                <th>Created</th>
                <th>Started</th>
                <th>IMSI</th>
                <th><i class="fab fa-whatsapp"></i> Active</th>
                <th><i class="fab fa-whatsapp"></i> Suspended</th>
                <th><i class="fab fa-usb"></i> Active</th>
                <th><i class="fab fa-usb"></i> Suspended</th>
                <!-- <th><i class="fa fa-laptop"></i> Active</th>
                <th><i class="fa fa-laptop"></i> Suspended</th> -->
                <th>send 10m</th>
                <th>send 1hr</th>
                <th>send 8hr</th>
                <th>send 1d</th>
                <th>carrierAliases</th>
              </tr>
            </thead>
            <tbody>
              
            </tbody>
          </table>
        </div>
        <hr />

      </div>
    </div>
  </div>
</template>

<script>
import store from "../store/store";
import moment from "moment";
import _ from "lodash";
import { map, get, find, toLower, } from "lodash";
import toast from "../services/toast";
import Loading from "../layouts/Loading";
// import $ from "jquery";
import url from 'url';

// import editable from './node_modules/x-editable/dist/bootstrap-editable/js/bootstrap-editable.js';

export default {
  name: "Phone",
  components: {
    Loading,
  },
  beforeDestroy() {
    this.tableTimer && clearInterval(this.tableTimer);
  },
  async mounted() {
    
    if (!$('#accordionSidebar').hasClass('toggled')){
      $('#accordionSidebar').addClass('toggled')
    }

    let self = this;

    $.fn.dataTable.ext.errMode = "none";

    // editor = new $.fn.dataTable.Editor({
    //   ajax: "../php/staff.php",
    //   table: "#example",
    //   fields: [
    //     {
    //       label: "Name:",
    //       name: "name",
    //     },
    //   ],
    // });

    // $(".editable-text").editable("save.php");

    $.fn.dataTable.ext.buttons.reload = {
      text: self.txt("Refresh"),
      className: "btn-sm btn-warning",
      action: function (e, dt, node, config) {
        console.log('refreshing')
        dt.ajax.reload();
        // console.log(dt.columns.adjust().draw())
      },
    };

    self.tableTimer = setInterval(() => {
      if ($(".editable.editable-open").length) {
        console.log("editable opened, skip reload");
        return;
      }

      if (document.hidden){
        if (_.random(1, 100) < 90){
          console.log("window not active, skip reload");
          return 
        }
      }

      if (!this.isEditableLoaded){
        console.log('editable skip reload')
        return 
      }

      table.ajax.reload();
    // }, 1000 * 3 * 1); // remove test
    }, 1000 * 60 * 1); 

    let $table = $("#table-phones");
    let table = $table.DataTable({
      dom: "Blftip",
      searching: true,
      buttons: [
        // "pdf",
        "reload",
        // {
        //   text: "My button",
        //   action: function (e, dt, node, config) {
        //     alert("Button activated");
        //   },
        // },
      ],
      paging: false,
      ordering: true,
      info: false,
      fixedColumns: false,
      autoWidth: false,
      columnDefs: [
        {
          // orderable: false,
          // targets: [1, 2, 3],
        },
        // set width not working
        // ref: https://datatables.net/reference/option/columns.width
        // { 
        //   "width": 500, 
        //   // "width": "50%", 
        //   "targets": 8
        // }
      ],
      rowId: "_id",
      columns: [
        // { data: "_id" },
        {
          data: "name",
          render(data, type, row) {
            // Check if archived
            let isArchived = get(row, "settingParsed.archive", false);
            
            // Check isTransferAvailable from settingParsed
            let isTransferAvailable = true;
            if (row.settingParsed && row.settingParsed.isTransferAvailable === false) {
              isTransferAvailable = false;
            }

            // Check if settingParsed.shared.from is not empty
            let isShared = false;
            if (row.settingParsed && row.settingParsed.shared && row.settingParsed.shared.from) {
              isShared = true;
            }

            // Check if alert.wa is false (skip for WABA phones)
            let isNoAlert = get(row, "settingParsed.alert.wa") === false && !row.WABAActive;

            // Check if remark contains 'blocked', 'restricted', 'sign out' or 'login fail' in last line of wa block section
            let isBlocked = false;
            let isRestricted = false;
            if (row.remark) {
              const lines = row.remark.split(/\r?\n/);
              let waBlockStart = lines.findIndex(line => line.trim().toLowerCase().startsWith('wa block:') || line.trim().toLowerCase().startsWith('- wa block:'));
              if (waBlockStart !== -1) {
                // Find next section: a non-empty line that starts with a letter and is not indented, excluding date lines
                let waBlockEnd = lines.slice(waBlockStart + 1).findIndex(line => {
                  const trimmed = line.trim();
                  // Skip empty lines
                  if (!trimmed) return false;
                  // Match lines that start with a letter (new sections) but not date lines (yyyy-mm-dd or yyyymmdd format)
                  return /^[a-zA-Z]/.test(trimmed) && !/^\d{4}[-\s]?\d{2}[-\s]?\d{2}/.test(trimmed);
                });
                waBlockEnd = waBlockEnd === -1 ? lines.length : waBlockStart + 1 + waBlockEnd;
                const waBlockLines = lines.slice(waBlockStart + 1, waBlockEnd).filter(line => line.trim());
                if (waBlockLines.length > 0) {
                  const lastWaBlockLine = waBlockLines[waBlockLines.length - 1].toLowerCase();
                  if (lastWaBlockLine.includes('blocked')) {
                    isBlocked = true;
                  }
                  if (lastWaBlockLine.includes('restricted') || lastWaBlockLine.includes('sign out') || lastWaBlockLine.includes('login fail')) {
                    isRestricted = true;
                  }
                }
              }
            }
            
            return `
              <span class="$ {
                row.isSimHealthy !== null
                  ? row.isSimHealthy
                    ? "text-success"
                    : "text-danger"
                  : "text-light-"
              }">
                *${row.name}*
                ${
                  !row.smsWebSuspended
                    ? `<span class="badge badge-grey">
                      <i class="fab fa-chrome"></i>
                    </span>`
                    : ""
                }
                ${
                  !row.smsSuspended
                    ? `<span class="badge badge-grey">
                      <i class="fas fa-signal"></i>
                    </span>`
                    : ""
                }
              </span>

              ${
                !isArchived && row.isSimHealthy !== null
                  ? row.isSimHealthy
                    ? `<span class="badge badge-success" title="${moment(
                        row.lastHeartBeatTimeString
                      ).format(
                        "Y-MM-DD HH:mm:ss"
                      )}"><i class="fa fa-comment-alt"></i> UP</span>`
                    : `<span class="badge badge-danger" title="${moment(
                        row.lastHeartBeatTimeString
                      ).format(
                        "Y-MM-DD HH:mm:ss"
                      )}"><i class="fa fa-comment-alt"></i> DOWN</span>`
                  : ""
              }

              ${
                !isArchived && row.isNeedTopupToday
                  ? `<span class="badge badge-warning">
                  <i class="fas fa-dollar-sign"></i>
                  TOPUP
                  </span>`
                  : ""
              }
              ${
                !isArchived && row.validityDays
                  ? `<span class="badge ${
                      row.validityDays <= 2 ? "badge-danger" : "badge-info"
                    }" title="latestTopUpAt: ${moment(row.latestTopUpAt).format("Y-MM-DD")}, expires at ${moment().add(row.validityDays, 'day').format('Y-MM-DD')}">
                  <i class="fas fa-sim-card"></i>
                  ${row.validityDays}D
                  </span>`
                  : ""
              }
              ${
                !isArchived && (row.accountEmail
                  ? `<span class="badge badge-success">
                    <i class="fab fa-whatsapp text-white"></i> ${row.accountEmail}</span>`
                  : row.whatsappActive && !row.whatsappSuspended
                  ? `<span class="badge badge-success">
                      <i class="fab fa-whatsapp text-white"></i>
                    </span>`
                  : "")
              }
              ${
                !isArchived && row.isWaba
                  ? `<span class="badge badge-success">
                      <i class="fab fa-whatsapp text-white"></i> *WABA*
                    </span>`
                  : ""
              }
              ${
                !isArchived && (get(row, "sentToday") || get(row, "sentTotal"))
                  ? `<span class="badge badge-info">sent ${get(row, "sentToday", 0)}/${_.round(get(row, "sentTotal", 0) / 1000, 1)}k</span>`
                  : ""
              }
              ${
                !isArchived && get(row, "appVncLink")
                  ? `<span class="badge badge-success">
                  <a href="${row.appVncLink}" target="_blank" class="text-white">
                    <span class="fa fa-mobile-alt"></span>
                    OPEN
                  </a>
                </span>`
                  : ""
              }
              ${
                !isArchived && get(row, "webVncLink")
                  ? `<span class="badge badge-success">
                  <a href="${row.webVncLink}" target="_blank" class="text-white">
                    <span class="fa fa-desktop"></span>
                    OPEN
                  </a>
                </span>`
                  : ""
              }
              ${
                !isArchived && get(row, "webNovncLink")
                  ? `<span class="badge badge-success">
                  <a href="${row.webNovncLink}" target="_blank" class="text-white">
                    <span class="fa fa-window-maximize"></span>
                    OPEN
                  </a>
                </span>`
                  : ""
              }
              ${
                !isArchived && get(row, "arenaUrl")
                  ? `<span class="badge badge-success">
                  <a href="${row.arenaUrl}" target="_blank" class="text-white">
                    <span class="fa fa-cogs"></span>
                    OPEN
                  </a>
                </span>`
                  : ""
              }
              ${
                isArchived
                  ? `<span class="badge badge-secondary">*ARCHIVED*</span>`
                  : ""
              }
              ${
                isShared && !isArchived
                  ? `<span class="badge badge-warning">*SHARED*</span>`
                  : ""
              }
              ${
                isBlocked && !isArchived
                  ? `<span class="badge badge-danger">*BLOCKED*</span>`
                  : ""
              }
              ${
                isRestricted && !isArchived
                  ? `<span class="badge badge-danger">*RESTRICTED*</span>`
                  : ""
              }
              ${
                !isTransferAvailable && !isArchived
                  ? `<span class="badge badge-danger">*NO TRANSFER*</span>`
                  : ""
              }
              ${
                isNoAlert && !isArchived
                  ? `<span class="badge badge-danger">*NO ALERT*</span>`
                  : ""
              }`;
          },
        },
        // { data: "tags", className: "editable-tags" },
        {
          // waState - derived operational state (see SKILL.md "WhatsApp Device Model").
          // duty = isTransferAvailable !== false; live = WA Web agent heartbeat (agentHealth).
          data: null,
          render(data, type, row) {
            if (get(row, "settingParsed.archive", false)) {
              return `<span class="badge badge-secondary">ARCHIVED</span>`;
            }

            let duty =
              !(row.settingParsed && row.settingParsed.isTransferAvailable === false);
            // alert.wa:false devices are unmonitored placeholders omitted from /agent/health,
            // so treat them as not-live (matches wa_status.py).
            let live =
              row.isWhHealthy === true &&
              get(row, "settingParsed.alert.wa") !== false;

            let state, cls;
            if (row.isWaba) {
              state = "WABA";     cls = "badge-info";    // WABA-registered, never containerized
            } else if (duty && live) {
              state = "SERVING";  cls = "badge-success"; // carrying WA-Web now
            } else if (duty && !live) {
              state = "STRANDED"; cls = "badge-warning"; // should serve, session dead
            } else if (live) {
              state = "SPARE";    cls = "badge-primary"; // session live, not enrolled
            } else {
              state = "PARKED";   cls = "badge-dark";    // row kept as fromPhone entitlement
            }
            return `<span class="badge ${cls}">${state}</span>`;
          },
        },
        { data: "simHost", className: "editable-text" },
        { data: "whatsappHost", className: "editable-text" },
        { data: "whatsappHostPort", className: "editable-text" },
        { data: "whatsappWebHost", className: "editable-text" },
        { data: "port", className: "editable-text" },
        { data: "phoneNumber", className: "editable-text" },
        { data: "estimatedBalance", className: "editable-text" },
        
        { 
          data: "remark", 
          className: "editable-textarea field-remark",
          render(data, type) {

            if (type === 'display' && data !== null && data !== undefined) {
              // convert string to html entity
              data = data.replace(/[\u00A0-\u9999<>\&]/gim, function(i) {
                return '&#'+i.charCodeAt(0)+';';
              });
              // replace all space to &nbsp;
              data = data.replace(/ /g, '&nbsp;');
              // replace all new line with <br>
              data = data.replace(/(?:\r\n|\r|\n)/g, '<br>');
              return data;
            }

            return data;
          },
        },
        { 
          data: "setting", 
          className: "editable-textarea field-setting",
          render(data, type) {

            if (type === 'display' && data !== null && data !== undefined) {
              // convert string to html entity
              data = data.replace(/[\u00A0-\u9999<>\&]/gim, function(i) {
                return '&#'+i.charCodeAt(0)+';';
              });
              // replace all space to &nbsp;
              data = data.replace(/ /g, '&nbsp;');
              // replace all new line with <br>
              data = data.replace(/(?:\r\n|\r|\n)/g, '<br>');
              return data
            }
            
            return data;
          },
        },
        { data: "transferJobRate", className: "editable-text" },
        {
          data: "createdAt",
          render(data) {
            return (
              data &&
              `${moment(data).format("Y-MM-DD")} (${moment(data).fromNow()})`
            );
          },
        },
        {
          data: "startedAt",
          className: "editable-text",
          render(data) {
            return (
              data &&
              `${moment(data).format("Y-MM-DD")} (${moment(data).fromNow()})`
            );
          },
        },
        { data: "IMSI", className: "editable-text" },
        { data: "whatsappActive", className: "editable-text" },
        { data: "whatsappSuspended", className: "editable-text" },
        { data: "smsActive", className: "editable-text" },
        { data: "smsSuspended", className: "editable-text" },
        // { data: "smsWebActive", className: "editable-text" },
        // { data: "smsWebSuspended", className: "editable-text" },
        {
          data: "sendSetting.throttle.countTenMinute",
          className: "editable-text",
        },
        {
          data: "sendSetting.throttle.countOneHour",
          className: "editable-text",
        },
        {
          data: "sendSetting.throttle.countEightHour",
          className: "editable-text",
        },
        {
          data: "sendSetting.throttle.countOneDay",
          className: "editable-text",
        },
        { data: "carrierAliases[]" },
      ],
      //  buttons: [
      //       { extend: "create", editor: editor },
      //       { extend: "edit",   editor: editor },
      //       { extend: "remove", editor: editor }
      //   ],
      ajax: (data, callback, settings) => {
        (async () => {
          // console.log("datatable ajax");

          try {
            let [
              {
                data: { phoneNumberInventory, hostMap, hostMapv2 },
              },
              { data: reportData },
              { data: devices },
              { data: {
                queues
              } },
              { data: { unhealthy = [] } = {} },
            ] = await Promise.all([
              this.axios.get("/phoneNumberInventory"),
              this.axios.get("/report/status"),
              this.axios.get("/report/device", {
                params: { skipNotice: true },
              }),
              this.axios.get("/whatsapp-agent/arena"),
              // WA Web liveness: /agent/health returns { unhealthy:[...] }; HTTP 400 when any unhealthy.
              this.axios.get("/agent/health", {
                validateStatus: (status) => status < 500,
                timeout: 8000,
              }),
            ]);

            // phones whose WA agent has no live heartbeat (also covers cmhk-37 today)
            let unhealthyPhoneNames = new Set(
              map(unhealthy, (d) => get(d, "phoneName"))
            );

            let {
              NODE_ENV
            } = process.env || {}

            // console.log({queues, envs: process.env})
            
            // Debug: Check devices for WABAActive
            console.log('All devices:', devices.map(d => ({
              name: get(d, 'phone.name'),
              WABAActive: get(d, 'WABAActive'),
              device: d
            })));

            toast.success("data loaded");

            self.reportData = reportData;

            let rows = [];
            map(phoneNumberInventory, (row) => {
              row.isSimHealthy = null;

              let deviceQueue = find(queues, {phoneName: get(row, 'name')})
              let arenaUrl
              // console.log(get(row, 'name'), deviceQueue)
              if (get(row, 'name') && deviceQueue){
                // console.log({NODE_ENV,debug: [
                //   this.foo,
                //   this.env,
                // ] })
                let arenaHost = this.env === 'prod' ? 'https://arena.supermeteor.com' : 'https://arena-uat.supermeteor.com'
                arenaUrl = `${arenaHost}/${get(deviceQueue, 'name')}/${get(deviceQueue, 'name')}`
              }
              row.arenaUrl = arenaUrl

              let device = find(
                devices,
                (device) => get(device, "phone.name") === row.name
              );
              let accountEmail =
                get(device, "account.email", "") &&
                get(device, "account.email", "").substring(0, 6) + "*@**";
              row.accountEmail = accountEmail;
              // inventory row's own WABAActive flag (before it is overwritten below)
              let inventoryWaba = get(row, "WABAActive", false) === true;
              row.WABAActive = get(device, "phone.WABAActive", false);
              // display-only: also treat inventory WABAActive rows as WABA
              // (covers e.g. hk-10/hk-12 which have no device row).
              row.isWaba = row.WABAActive || inventoryWaba;
              // live = has a WA device row AND absent from /agent/health.unhealthy
              row.isWhHealthy =
                !!device && !unhealthyPhoneNames.has(row.name);

              let whatsappHost = _.get(hostMap, _.get(row, "whatsappHost"));
              let whatsappWebHost = _.get(
                hostMap,
                _.get(row, "whatsappWebHost")
              );
              // whatsappHost &&
                // console.log({ row, hostMap, whatsappWebHost, whatsappHost });
              row.appVncLink = whatsappHost
                ? `vnc://${whatsappHost}:${_.get(row, "whatsappHostPort")}`
                : null;
              // Hide VNC links if no valid whatsappWebHost or WABAActive is true
              row.webVncLink = (whatsappWebHost && !row.WABAActive)
                ? `vnc://${whatsappWebHost}:${_.get(row, "port")}`
                : null;
              // e.g. https://g2-vnc.lncknight.com/g1/6961/?path=socket_io%3Fport%3D6961%26host%3Dg1
              // socket_io?port=6961&host=g1
              let hostMapV2Item = _.find(hostMapv2, {origin: whatsappWebHost})
              let novncShortHost =  _.get(hostMapV2Item, 'novncShortHost')
              let novncHost =  _.get(hostMapV2Item, 'novnc')
              let novncPort = _.toString(_.toInteger(_.get(row, "port")) + 1000)
              
              // Hide noVNC link if no valid whatsappWebHost or WABAActive is true
              row.webNovncLink = (whatsappWebHost && !row.WABAActive)
                ? `https://${novncHost}/${novncShortHost}/${novncPort}/?path=socket_io%3Fport%3D${novncPort}%26host%3D${novncShortHost}&password=`
                : null;

              map(get(reportData, "phones"), (phone) => {
                // if (!get(phone, "identifiers.name")) {
                //   return;
                // }

                // if (get(phone, "identifiers.name") === null){
                //   return rows.push(row)
                // }

                if (get(phone, "identifiers.name") !== get(row, "name")) {
                  return;
                }

                let shouldSimOnline =
                  (!get(row, "smsSuspended") && get(row, "smsActive")) ||
                  (!get(row, "smsWebSuspended") && get(row, "smsWebActive"));
                let lastHeartBeatTimeString = get(row, "lastHeartbeatAt");
                let isSimHealthy = shouldSimOnline
                  ? lastHeartBeatTimeString &&
                    new Date().getTime() -
                      moment(lastHeartBeatTimeString).toDate().getTime() <
                      3 * 60 * 1000
                  : null;

                // let timeDiff = _.round(
                //   (
                //     new Date().getTime() -
                //     moment(lastHeartBeatTimeString).toDate().getTime()
                //   ) / 1000
                // )
                // console.log(row.name, {
                //   shouldSimOnline,
                //   lastHeartBeatTimeString,
                //   isSimHealthy,
                // });

                row.isSimHealthy = isSimHealthy;
                // row.sentToday = get(phone, 'status.dollarWillEndupToday', 'NA')
                row.sentToday = get(phone, "status.sentToday", "NA");
                row.isNeedTopupToday = get(phone, "status.isNeedTopupToday");
              });

              return rows.push(row);
            });

            // console.log({ reportData });

            // Calculate summary
            self.summary = {
              total: rows.length,
              blocked: 0,
              restricted: 0,
              shared: 0,
              noTransfer: 0,
              noAlert: 0,
              archived: 0,
              waba: 0
            };

            rows.forEach(row => {
              // Check if archived first
              const isArchived = get(row, "settingParsed.archive", false);

              // Check remark for blocked/restricted/sign out/login fail in wa block section (exclude archived)
              if (!isArchived && row.remark) {
                const lines = row.remark.split(/\r?\n/);
                let waBlockStart = lines.findIndex(line => line.trim().toLowerCase().startsWith('wa block:') || line.trim().toLowerCase().startsWith('- wa block:'));
                if (waBlockStart !== -1) {
                  let waBlockEnd = lines.slice(waBlockStart + 1).findIndex(line => {
                    const trimmed = line.trim();
                    return trimmed && /^[a-zA-Z]/.test(trimmed) && !/^\d{4}[-\s]?\d{2}[-\s]?\d{2}/.test(trimmed);
                  });
                  waBlockEnd = waBlockEnd === -1 ? lines.length : waBlockStart + 1 + waBlockEnd;
                  const waBlockLines = lines.slice(waBlockStart + 1, waBlockEnd).filter(line => line.trim());
                  if (waBlockLines.length > 0) {
                    const lastWaBlockLine = waBlockLines[waBlockLines.length - 1].toLowerCase();
                    
                    // Blocked: check if last line contains "blocked"
                    if (lastWaBlockLine.includes('blocked')) {
                      self.summary.blocked++;
                    }
                    
                    // Restricted: check if last line contains restricted/sign out/login fail
                    if (lastWaBlockLine.includes('restricted') || lastWaBlockLine.includes('sign out') || lastWaBlockLine.includes('login fail')) {
                      self.summary.restricted++;
                    }
                  }
                }
              }

              // Shared: check if settingParsed.shared.from is not empty (exclude archived)
              if (!isArchived && row.settingParsed && row.settingParsed.shared && row.settingParsed.shared.from) {
                self.summary.shared++;
              }

              // No Transfer: check if settingParsed.isTransferAvailable is false (exclude archived)
              if (!isArchived && row.settingParsed && row.settingParsed.isTransferAvailable === false) {
                self.summary.noTransfer++;
              }

              // No Alert: check if alert.wa is false (exclude archived and WABA)
              if (!isArchived && get(row, "settingParsed.alert.wa") === false && !row.WABAActive) {
                self.summary.noAlert++;
              }

              // Archived: check if settingParsed.archive is true
              if (isArchived) {
                self.summary.archived++;
              }

              // WABA: check if WABAActive is true (device or inventory flag)
              if (row.isWaba) {
                self.summary.waba++;
              }
            });

            // Render chart
            self.$nextTick(() => {
              self.renderChart();
            });

            callback({
              data: rows,
            });
          } catch (err) {
            console.log(err);
            callback({
              data: [],
            });
          }
        })();

        // store.commit("loading", false);
      },
      rowCallback: function (row, data, index) {
        // console.log({ row, data, index });
        // remark contains has tag #soft_release, then remove editable-text class on SIM column (i.e. 2nd, 3rd, 4th cols)
        let isSoftRelease = /#soft_release/.test(data.remark)
        if (isSoftRelease){
          $(row).find('td').slice(2, 5).removeClass('editable-text')
          // and cell value display as disabled
          $(row).find('td').slice(2, 5).html(function(i, v){
            return `<span class="text-muted">disabled</span>`
          })
      }

      },
    });

    let currentUrl = self.$route.fullPath
    // console.log({
    //   currentUrl,
    //   debug: [
    //     self.$route.query.page,
    //     self.$route,
    //     self.$route.query,
    //   ]
    //   })
    if (currentUrl){
    let urlobj = url.parse(currentUrl, true)
    // let urlobj = url.parse(currentUrl, true)
        // console.log({
        //   urlobj,
        //   query: urlobj.query
        // })
        table.search(get(urlobj.query, 'q'))
    }
            
    // ref: https://vitalets.github.io/x-editable/docs.html
    let initEditable = () => {

      // $(
      //   "td.editable-text, td.editable-textarea, td.editable-tags"
      // ).editable("destroy");
      
      console.info('initEditable')

      $("td.editable-text").editable({
        mode: "inline",
        type: "text",
        // ajaxOptions: {
        //   type: "put",
        // },
        // url: "/save.php",
        // savenochange(a) {
        //   console.log(a);
        // },
      });
      $("td.editable-textarea").editable({
        mode: "inline",
        type: "textarea",
        // get actual data from data-attributes - not working
        // value: function (params) {
        //   return $(this).data("value");
        // },
      });
      $("td.editable-tags").editable({
        mode: "inline",
        type: "select2",
        // source: [
        //   { id: "gb", text: "Great Britain" },
        //   { id: "us", text: "United States" },
        //   { id: "ru", text: "Russia" },
        // ],
        select2: {
          multiple: true,
          tags: true,
          // tokenSeparators: [',', ' '],
        },
      });

      let getDataTableCellInfoFromElem = (elem) => {
        let self2 = elem;
        // ref: https://datatables.net/forums/discussion/49576/get-specific-cell-value-using-row-col-index-coordinates
        var { row, column } = table.cell(self2).index();
        var rowid = table.row(row).id();

        
        let rowdata = table.row(row).data();
        window.foo = table // TODO remove test debug

        let celldata
        try {
          let sortedRowIndex = table.column(column).rows()[0].indexOf(row)
          celldata = table.column(column).data()[sortedRowIndex]
        }
        catch(err){
          // alert error
          console.error(err)
          alert('error on getDataTableCellInfoFromElem: ' + err.message)

        }
        
        console.log('getDataTableCellInfoFromElem', { row, column, rowid, rowdata, celldata });
        return { row, column, rowid, rowdata, celldata };
      };

      $("td.editable-textarea").on(
        "shown",
        function (e, editable) {
          let { celldata } = getDataTableCellInfoFromElem(this)
          // set textarea value
          editable.input.$input.val(celldata);

          window.foo = this
          // update height of textarea of sibling .editable-container element to taller
          $(this).siblings('.editable-container').find('textarea').css('height', '500px')

          console.log('editable-textarea shown', { e, editable, celldata })
        }
      )

      $("td.editable-text, td.editable-textarea, td.editable-tags").on(
        "save",
        function (e, params) {
          let self2 = this;

          toast.success("updating..");
          (async () => {
            console.log({ e, params, self2 });

            let { row, column, rowid, rowdata, celldata } = getDataTableCellInfoFromElem(self2)

            // https://datatables.net/reference/api/
            // let colname = table.column(column).name();
            window.table = table; // TODO remove test
            let colname = table.column(column).dataSrc();
            // console.log({ colname });

            let body = {};
            if (/Active/.test(colname) || /Suspended$/.test(colname)) {
              body[colname] = 
                (
                  toLower(params.newValue) === "true" 
                  || toLower(params.newValue) === "t" 
                  || toLower(params.newValue) === "yes" 
                  || toLower(params.newValue) === "y" 
                )
                ? true : false;
            } else if (/sendSetting\.throttle/.test(colname)) {
              body[colname] = parseInt(params.newValue);
            } else {
              body[colname] = params.newValue;
            }

            // store.commit("loading", true);

            try {
              await self.axios.put(`phoneNumberInventory/${rowid}`, body);
              toast.success("updated, refreshing..");

              // disallow edit while updating
              $(
                "td.editable-text, td.editable-textarea, td.editable-tags"
              ).editable("destroy");
            } catch (err) {
              toast.error(err.response.data.message);
            }

            // store.commit("loading", false);

            table.ajax.reload();
          })();
        }
      );
    };

    // https://datatables.net/reference/event/
    $("#table-phones").on("draw.dt", () => {
      // let self = this;
      console.log('editable draw', this.isEditableLoaded)

      if (!this.isEditableLoaded){
        console.log('load editable')
        this.isEditableLoaded = true
        initEditable();
      }

    });

    $("#table-phones").on("search.dt", () => {
      // let self = this;

      console.log('search')
    });
    $("#table-phones").on("xhr.dt", () => {
      // let self = this;

      self.isEditableLoaded = false
      console.log('xhr')
    });

  },
  async beforeCreate() {
    // store.commit("loading", true);

    console.log("created");

    let loadScript = async (url) => {
      return $.ajax({
        url,
        type: "GET",
        dataType: "script",
        cache: true,
      }).promise();
    };

    await Promise.all(
      map(
        [
          "https://cdn.datatables.net/1.10.22/js/jquery.dataTables.min.js",

          // docs: https://vitalets.github.io/x-editable/docs.html
          "https://cdnjs.cloudflare.com/ajax/libs/x-editable/1.5.1/bootstrap3-editable/js/bootstrap-editable.min.js",
          "https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.13/js/select2.min.js",
        ],
        loadScript
      )
    );

    await loadScript(
      "https://cdn.datatables.net/buttons/1.6.4/js/dataTables.buttons.min.js"
    );

    // Load Chart.js
    await loadScript(
      "https://cdn.jsdelivr.net/npm/chart.js@3.9.1/dist/chart.min.js"
    );

    // Load Chart.js datalabels plugin
    await loadScript(
      "https://cdn.jsdelivr.net/npm/chartjs-plugin-datalabels@2.0.0"
    );

    console.log("script loaded");
    await loadScript(
      "https://cdn.datatables.net/buttons/1.6.4/js/dataTables.buttons.min.js"
    );

    console.log("script loaded");

    // let script = document.createElement("script");
    // script.setAttribute(
    //   "src",
    //   "https://cdn.datatables.net/1.10.22/js/jquery.dataTables.min.js"
    // );
    // document.head.appendChild(script);

    // let script2 = document.createElement("script");
    // script2.setAttribute(
    //   "src",
    //   "https://cdnjs.cloudflare.com/ajax/libs/jeditable.js/1.7.3/jeditable.min.js"
    // );
    // document.head.appendChild(script2);

    // ref: https://cdnjs.com/libraries/x-editable
    // let script3 = document.createElement("script");
    // script3.setAttribute(
    //   "src",
    //   // "https://cdnjs.cloudflare.com/ajax/libs/x-editable/1.5.1/jquery-editable/js/jquery-editable-poshytip.min.js"
    //   "https://cdnjs.cloudflare.com/ajax/libs/x-editable/1.5.1/bootstrap3-editable/js/bootstrap-editable.min.js"
    // );
    // document.head.appendChild(script3);
  },
  data: function () {
    return {
      tableTimer: null,
      reportData: null,
      summary: null,
      chart: null,

      isEditableLoaded: false,
      tableTimer: null,
      reportData: null,
      summary: null,

      isEditableLoaded: false,

      // isLoading: true,
      table: {
        // deprecated
        fields: [
          {
            key: "_id",
            sortable: true,
            label: this.txt("ID"),
            formatter: (value, key, item) => {
              return item._id;
            },
          },
          {
            key: "name",
            sortable: true,
            label: this.txt("Name"),
          },
          { key: "IMSI", sortable: true, label: this.txt("IMSI") },
          { key: "createdAt", sortable: true, label: this.txt("createdAt") },
          {
            key: "estimatedBalance",
            sortable: true,
            label: this.txt("Estimated balance"),
          },
          {
            key: "phoneNumber",
            sortable: true,
            label: this.txt("phoneNumber"),
          },
          {
            key: "transferJobRate",
            sortable: true,
            label: this.txt("Job Transfer Rate"),
          },
          { key: "smsActive", sortable: true, label: this.txt("smsActive") },
          {
            key: "smsSuspended",
            sortable: true,
            label: this.txt("smsSuspended"),
          },
          {
            key: "smsWebActive",
            sortable: true,
            label: this.txt("smsWebActive"),
          },
          {
            key: "smsWebSuspended",
            sortable: true,
            label: this.txt("smsWebSuspended"),
          },
          {
            key: "whatsappActive",
            sortable: true,
            label: this.txt("whatsappActive"),
          },
          {
            key: "sendSetting",
            sortable: true,
            label: this.txt("sendSetting"),
          },
          {
            key: "estimatedBalance",
            sortable: true,
            label: this.txt("estimatedBalance"),
          },
          {
            key: "carrierAliases",
            sortable: true,
            label: this.txt("carrierAliases"),
          },
          { key: "account", sortable: true, label: this.txt("account") },
          { 
            key: "remark", 
            sortable: true, 
            label: this.txt("remark"),
            },
        ],
        sortBy: "_id",
        sortOrder: true,
        page: 0,
        limit: 30,
        // isLoading: false,
      },
    };
  },
  methods: {
    renderChart() {
      if (!this.summary) return;
      
      const ctx = document.getElementById('phoneStatsChart');
      if (!ctx) return;

      // Destroy existing chart
      if (this.chart) {
        this.chart.destroy();
      }

      // Prepare data and sort by value in descending order
      const dataItems = [
        { label: 'Total', value: this.summary.total, color: 'rgba(78, 115, 223, 0.8)', borderColor: 'rgba(78, 115, 223, 1)' },
        { label: 'Blocked', value: this.summary.blocked, color: 'rgba(231, 74, 59, 0.8)', borderColor: 'rgba(231, 74, 59, 1)' },
        { label: 'Restricted', value: this.summary.restricted, color: 'rgba(231, 74, 59, 0.8)', borderColor: 'rgba(231, 74, 59, 1)' },
        { label: 'Shared', value: this.summary.shared, color: 'rgba(246, 194, 62, 0.8)', borderColor: 'rgba(246, 194, 62, 1)' },
        { label: 'No Transfer', value: this.summary.noTransfer, color: 'rgba(231, 74, 59, 0.8)', borderColor: 'rgba(231, 74, 59, 1)' },
        { label: 'No Alert', value: this.summary.noAlert, color: 'rgba(231, 74, 59, 0.8)', borderColor: 'rgba(231, 74, 59, 1)' },
        { label: 'Archived', value: this.summary.archived, color: 'rgba(133, 135, 150, 0.8)', borderColor: 'rgba(133, 135, 150, 1)' },
        { label: 'WABA', value: this.summary.waba, color: 'rgba(28, 200, 138, 0.8)', borderColor: 'rgba(28, 200, 138, 1)' }
      ];

      // Sort by value descending
      dataItems.sort((a, b) => b.value - a.value);

      // Create new chart
      this.chart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: dataItems.map(item => item.label),
          datasets: [{
            label: 'Count',
            data: dataItems.map(item => item.value),
            backgroundColor: dataItems.map(item => item.color),
            borderColor: dataItems.map(item => item.borderColor),
            borderWidth: 1
          }]
        },
        options: {
          maintainAspectRatio: false,
          responsive: true,
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                stepSize: 1
              }
            }
          },
          plugins: {
            legend: {
              display: false
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  return 'Count: ' + context.parsed.y;
                }
              }
            },
            datalabels: {
              anchor: 'end',
              align: 'top',
              formatter: function(value) {
                return value;
              },
              font: {
                weight: 'bold',
                size: 12
              }
            }
          }
        },
        plugins: [ChartDataLabels]
      });
    },
    async search(ctx) {
      // this.table.isLoading = true;
      let aId = localStorage.getItem("accountId");
      let params = { sortBy: this.table.sortBy };
      params.sortOrder = this.table.sortOrder ? -1 : 1;

      // let url = `/account/${this.$store.getters.accountID}/messages`;
      let url = `/phoneNumberInventory`;

      let {
        data: { phoneNumberInventory },
      } = await this.axios.get(url, {
        params,
      });

      // this.table.isLoading = false;

      return phoneNumberInventory;
    },
  },
};
</script>

<style>
/* not working */
/* .remarkCol{
  width: 500px;
  padding-left: 150px;
  padding-right: 150px;
} */

.glyphicon-ok:before {
  content: "Save";
  font-family: "Avenir, Helvetica, Arial, sans-serif";
}
.glyphicon-remove:before {
  content: "Cancel";
  font-family: "Avenir, Helvetica, Arial, sans-serif";
}
.glyphicon {
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

td.editable-text {
  text-decoration: underline;
}

.field-remark, .field-setting, .editable-container textarea {
  text-align: left;
  font-family: jetbrains Mono, Menlo, Monaco, Consolas, "Courier New", monospace;
}

textarea {
  resize: auto !important;
  width: 100% !important;
  
}
.editable-inline .form-inline {
  display: block;
}
.editable-inline .form-group {
  display: block !important;
}

</style>